// Copyright (c) 2022 by Move Closer

import { ComponentObjectPropsOptions } from '../../../vue-api'
import {
  canBeDisabledProp,
  hasErrorsProp,
  hasSizeProp
} from '../../../composables'

import { FormControlBaseProps } from '../../general'

import { AbstractInputControlProps } from './InputControl.contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const getAbstractBaseControlProps = <ModelType> (): ComponentObjectPropsOptions<FormControlBaseProps<ModelType>> => ({
  ...canBeDisabledProp,
  ...hasSizeProp,
  ...hasErrorsProp,

  /**
   * @inheritDoc
   */
  autocomplete: {
    type: String,
    required: false
  },

  /**
   * @inheritDoc
   */
  autofocus: {
    type: Boolean,
    required: false,
    default: false
  },

  /**
   * @inheritDoc
   */
  id: {
    type: String,
    required: false,
    default: null
  },

  /**
   * @inheritDoc
   */
  label: {
    type: String,
    required: false,
    default: null
  },

  /**
   * @inheritDoc
   */
  model: { required: true },

  /**
   * @inheritDoc
   */
  name: {
    type: String,
    required: true
  },

  /**
   * @inheritDoc
   */
  placeholder: {
    type: String,
    required: false
  },

  /**
   * @inheritDoc
   */
  readonly: {
    type: Boolean,
    required: false,
    default: false
  },

  /**
   * @inheritDoc
   */
  required: {
    type: Boolean,
    required: false,
    default: false
  }
})

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const getAbstractInputControlProps = <ModelType> ():
  ComponentObjectPropsOptions<AbstractInputControlProps<ModelType>> => ({
    ...getAbstractBaseControlProps<ModelType>(),

    /**
   * @inheritDoc
   */
    autocomplete: {
      type: String,
      required: false
    },

    /**
   * @inheritDoc
   */
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
   * @inheritDoc
   */
    castAsNumber: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * @inheritDoc
     */
    maxlength: {
      type: Number,
      required: false,
      default: null
    }
  })
